import { type Option, type OptionValue } from "@/components/types/option";

import { Divider, type OptionFieldsConfig } from "../../SelectBase";

import { isSelected } from "./isSelected";

/**
 *
 * Inserta un divider entre el ùltimo elemento seleccionado y el siguiente
 *
 * PRE-Condicion: los elementos deben estar ordenados por selección
 */
export function insertDivider<TValue extends Option>(
  options: TValue[],
  selected: OptionValue<TValue>[] | undefined,
  fieldConfig: OptionFieldsConfig<TValue>,
): (TValue | Divider)[] {
  if (!selected || !Array.isArray(selected)) {
    return options;
  }

  const countSelected = selected.length ?? 0;
  if (options.length < 2 || countSelected === 0 || countSelected === options.length) {
    return options;
  }

  const index = options.findIndex((x) => !isSelected(x, selected, fieldConfig));

  const inserted: (TValue | Divider)[] = [...options];

  inserted.splice(index, 0, new Divider());

  return inserted;
}
